import React,{useState} from 'react';
import TagList from '../../tag/TagList';


export default function TagSelectModal(param) {

    function callbackCheckTag(tag) {
        param.callbackCheckTag(tag);
    }

    React.useEffect(() => {
    }, [param.projectId])

    return(
        <div className="modal fade" id="tagSelectModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl  modal-dialog-centered">
                <div className="modal-content">
                    
                    <div className="modal-header">
                        <h4 className="modal-title">태그 선택</h4>
                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        {/* <input className="form-control"  placeholder="프로그램명"/> */}
                        <div className="card">
                        <TagList projectId={param.projectId} callbackCheckTag={callbackCheckTag}></TagList>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}